<teleport to="body">
<div v-if="is_open" class="modal show d-block settings-modal-backdrop" tabindex="-1" role="dialog" aria-modal="true" @click.self="$emit('close')">
    <div v-if="visible_form_error" class="toast-container position-fixed bottom-0 end-0 p-3" aria-live="polite" aria-atomic="true">
        <div class="toast show align-items-center text-dark border-0 shadow-lg auth-toast auth-toast-error" role="alert">
            <div class="d-flex align-items-center gap-3 p-3">
                <span class="auth-toast-icon rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0" aria-hidden="true">
                    <i class="bi bi-exclamation-circle"></i>
                </span>
                <div class="toast-body p-0 fw-semibold lh-sm">{{ visible_form_error }}</div>
                <button type="button" class="btn-close ms-auto flex-shrink-0" aria-label="Dismiss error message" @click="clear_form_error"></button>
            </div>
        </div>
    </div>

    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-lg settings-user-modal-dialog" role="document">
    <div class="modal-content glass-card rounded-4 p-0 border border-dark overflow-hidden d-flex flex-column settings-user-modal-card">
        <div class="modal-header align-items-start border-bottom">
            <div>
                <h5 class="fw-bold mb-1">Add User</h5>
                <p class="text-muted text-xs mb-0">Create a new user and set their access level.</p>
            </div>

            <button type="button" class="btn btn-sm btn-outline-dark rounded-circle" @click="$emit('close')" aria-label="Close">
                <i class="bi bi-x-lg"></i>
            </button>
        </div>

        <form @submit.prevent="submit_form" class="settings-user-modal-form d-flex flex-column overflow-hidden">
            <div class="modal-body settings-user-modal-body">
            <SnackbarMessage
                :error-message="form_error"
                @dismiss-error="$emit('dismiss-error')"
            />

            <div class="row g-3">
                <div class="col-md-6">
                    <label for="settings-add-user-first-name" class="form-label text-xs fw-semibold">First name</label>
                    <input id="settings-add-user-first-name" ref="first_name_input" v-model.trim="user_form.first_name" type="text" :class="['form-control text-xs', field_errors.first_name ? 'border-danger' : 'border-secondary']" placeholder="Enter first name" autocomplete="given-name" :aria-invalid="field_errors.first_name ? 'true' : 'false'" :aria-describedby="field_errors.first_name ? 'settings-add-user-first-name-error' : null" required @input="validate_field('first_name', false)" @blur="validate_field('first_name')">
                    <div v-if="field_errors.first_name" id="settings-add-user-first-name-error" class="invalid-feedback d-block text-xs">
                        {{ field_errors.first_name }}
                    </div>
                </div>

                <div class="col-md-6">
                    <label for="settings-add-user-last-name" class="form-label text-xs fw-semibold">Last name</label>
                    <input id="settings-add-user-last-name" ref="last_name_input" v-model.trim="user_form.last_name" type="text" :class="['form-control text-xs', field_errors.last_name ? 'border-danger' : 'border-secondary']" placeholder="Enter last name" autocomplete="family-name" :aria-invalid="field_errors.last_name ? 'true' : 'false'" :aria-describedby="field_errors.last_name ? 'settings-add-user-last-name-error' : null" required @input="validate_field('last_name', false)" @blur="validate_field('last_name')">
                    <div v-if="field_errors.last_name" id="settings-add-user-last-name-error" class="invalid-feedback d-block text-xs">
                        {{ field_errors.last_name }}
                    </div>
                </div>

                <div class="col-md-6">
                    <label for="settings-add-user-email" class="form-label text-xs fw-semibold">Email</label>
                    <input id="settings-add-user-email" ref="email_input" v-model.trim="user_form.email" type="email" :class="['form-control text-xs', field_errors.email ? 'border-danger' : 'border-secondary']" placeholder="name@example.com" autocomplete="email" :aria-invalid="field_errors.email ? 'true' : 'false'" :aria-describedby="field_errors.email ? 'settings-add-user-email-error' : null" required @input="validate_field('email', false)" @blur="validate_field('email')">
                    <div v-if="field_errors.email" id="settings-add-user-email-error" class="invalid-feedback d-block text-xs">
                        {{ field_errors.email }}
                    </div>
                </div>

                <div class="col-md-6">
                    <label for="settings-add-user-phone" class="form-label text-xs fw-semibold">Phone</label>
                    <input id="settings-add-user-phone" ref="phone_input" v-model.trim="user_form.phone_number" type="tel" inputmode="numeric" pattern="[0-9]{10}" :class="['form-control text-xs', field_errors.phone_number ? 'border-danger' : 'border-secondary']" placeholder="0123456789" autocomplete="tel-national" :aria-invalid="field_errors.phone_number ? 'true' : 'false'" :aria-describedby="field_errors.phone_number ? 'settings-add-user-phone-error' : null" required @input="validate_field('phone_number', false)" @blur="validate_field('phone_number')">
                    <div v-if="field_errors.phone_number" id="settings-add-user-phone-error" class="invalid-feedback d-block text-xs">
                        {{ field_errors.phone_number }}
                    </div>
                </div>

                <div class="col-md-6">
                    <label for="settings-add-user-role" class="form-label text-xs fw-semibold">Role</label>
                    <select id="settings-add-user-role" ref="role_select" v-model="user_form.role_id" :class="['form-select text-xs', field_errors.role_id ? 'border-danger' : 'border-secondary']" :disabled="is_loading_roles" :aria-invalid="field_errors.role_id ? 'true' : 'false'" :aria-describedby="field_errors.role_id ? 'settings-add-user-role-error' : null" required @change="validate_field('role_id')">
                        <option v-if="is_loading_roles" value="">Loading roles...</option>
                        <option v-else value="" disabled>Select role</option>
                        <option v-for="role in role_options" :key="role.id" :value="role.id">{{ role.name }}</option>
                    </select>
                    <div v-if="field_errors.role_id" id="settings-add-user-role-error" class="invalid-feedback d-block text-xs">
                        {{ field_errors.role_id }}
                    </div>
                </div>

                <div class="col-12">
                    <div class="d-flex align-items-center justify-content-between gap-3 mb-2">
                        <label class="form-label text-xs fw-semibold mb-0">Assign properties</label>
                        <span class="badge rounded-pill text-bg-secondary bg-opacity-25 border border-light border-opacity-10 text-xs">
                            {{ selected_property_count }} selected
                        </span>
                    </div>

                    <div v-if="is_loading_properties" class="border rounded-3 p-3 text-muted text-xs">
                        Loading properties...
                    </div>

                    <div v-else-if="!property_options.length" class="border rounded-3 p-3 text-muted text-xs">
                        No active properties available.
                    </div>

                    <div v-else class="row g-2">
                        <div
                            v-for="property in property_options"
                            :key="property.id"
                            class="col-12 col-md-6"
                        >
                        <button
                            type="button"
                            ref="propertyButtons"
                            class="btn btn-sm w-100 d-flex align-items-center gap-2 text-start rounded-3"
                            :class="[is_property_selected(property.id) ? 'btn-primary' : 'btn-outline-dark', field_errors.property_ids ? 'border-danger' : '']"
                            :aria-pressed="is_property_selected(property.id)"
                            :aria-invalid="field_errors.property_ids ? 'true' : 'false'"
                            @click="toggle_property(property.id)"
                        >
                            <span class="d-inline-flex align-items-center justify-content-center rounded-circle border flex-shrink-0" style="width: 1.25rem; height: 1.25rem;" aria-hidden="true">
                                <i v-if="is_property_selected(property.id)" class="bi bi-check-lg"></i>
                            </span>
                            <span class="text-truncate">{{ property.name }}</span>
                        </button>
                        </div>
                    </div>
                    <div v-if="field_errors.property_ids" class="invalid-feedback d-block text-xs mt-2">
                        {{ field_errors.property_ids }}
                    </div>
                </div>
            </div>
            </div>

            <div class="modal-footer flex-shrink-0 border-top settings-user-modal-footer">
                <button type="button" class="btn btn-outline-dark btn-sm rounded-3 d-inline-flex align-items-center px-3 shadow-sm" @click="$emit('close')">
                    <span class="text-xs">Cancel</span>
                </button>

                <button
                    type="submit"
                    class="btn btn-primary btn-sm rounded-3 d-inline-flex align-items-center gap-1 px-3 shadow-sm"
                    :disabled="is_saving">
                    <span v-if="is_saving" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                    <span class="text-xs">Add user</span>
                </button>
            </div>
        </form>
    </div>
    </div>
</div>
</teleport>
